'use es6';

const HIGH = Number.POSITIVE_INFINITY;
const LOW = Number.NEGATIVE_INFINITY;

const valueOrDefault = (obj, fields, nullsLast) => {
  let value;

  if (Array.isArray(fields)) {
    value = fields.reduce((memo, key) => {
      return memo[key];
    }, obj);
  } else {
    value = obj[fields];
  }

  if (value && value.amount) {
    value = value.amount;
  }

  switch (typeof value) {
    case 'number':
      return value;

    case 'string':
      return value.toLowerCase();

    default:
      return nullsLast ? HIGH : LOW;
  }
}; // Takes a single field string, or an array of fields if nested value in object


const sort = (collection, fields, sortDir, nullsLast) => {
  return collection.sort((a, b) => {
    const af = valueOrDefault(a, fields, nullsLast);
    const bf = valueOrDefault(b, fields, nullsLast);

    if (af < bf) {
      return -1 * sortDir;
    } else if (af > bf) {
      return sortDir;
    } else {
      return 0;
    }
  });
};

export const sortCollection = (collection, fields, sortDir = 1, nullsLast = true) => {
  return sort(collection, fields, sortDir, nullsLast);
};